import React from "react";
import AboutSection from "../components/AboutSection";
import SEO from "../components/SEO";

const AboutPage = () => (
  <>
    <SEO
      title="Chi Siamo | Kyros Games"
      description="Kyros Games produce videogame autoprodotti per Windows con Store, launcher proprietario, account e community."
      canonical="https://kyrosgames.com/about"
      structuredData={{
        "@context": "https://schema.org",
        "@graph": [
          {
            "@type": "WebPage",
            "@id": "https://kyrosgames.com/about#webpage",
            "url": "https://kyrosgames.com/about",
            "name": "Chi Siamo | Kyros Games",
            "inLanguage": "it-IT",
            "isPartOf": { "@id": "https://kyrosgames.com/#website" },
            "breadcrumb": { "@id": "https://kyrosgames.com/about#breadcrumb" }
          },
          {
            "@type": "BreadcrumbList",
            "@id": "https://kyrosgames.com/about#breadcrumb",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://kyrosgames.com/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "Chi Siamo",
                "item": "https://kyrosgames.com/about"
              }
            ]
          }
        ]
      }}
    />
    <AboutSection />
  </>
);

export default AboutPage;
